<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import WorkflowForm from "../../../components/personnel/workflowlisting/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": WorkflowForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setupapprvlworkflow.newapprvlworkflow'),
      pageTitleValue: "",
      formData: {
        wftypeid: null,
        detailid: null,
        leavecode: null,
        workflowdetails: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (this.formData.override == true) {
        this.formData.override = 1;
      } else {
        this.formData.override = 0;
      }

      
      // if (this.formData.autoapr == false || this.formData.autoapr == null) {
      //   this.formData.autoapr = 0;
      // } else {
      //   this.formData.autoapr = 1;
      // }

      //  if (this.formData.email == false || this.formData.email == null) {
      //   this.formData.email = 0;
      // } else {
      //   this.formData.email = 1;
      // }

      //  if (this.formData.hronly == false || this.formData.hronly == null) {
      //   this.formData.hronly = 0;
      // } else {
      //   this.formData.hronly = 1;
      // }

      // if (this.formData.hrlast == false || this.formData.hrlast == null) {
      //   this.formData.hrlast = 0;
      // } else {
      //   this.formData.hrlast = 1;
      // }

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('post', {url: "/workflow/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "workflowlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "workflowlist" });
    },
  },
};
</script>